<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div v-if="!isLoaded" class="col-lg-12">
                <LoadingScreen :message="'Cargando Registros del Colaborador...'" />
            </div>
            <div v-if="isLoaded" class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección de Título -->
                            <div>
                                <h6 class="mb-2 ms-2">Registros Pendientes de Autorizar del Colaborador</h6>
                            </div>
                            <div class="d-flex">
                                <div v-if="!noRecords">
                                    <button v-if="selectedRecords.length === 0" class="btn btn-success mb-0"
                                        @click="authAll">
                                        <i class="fas fa-check"></i> Autorizar Todo</button>
                                    <button @click="authorizeSelected" class="btn btn-success mb-0"
                                        v-if="selectedRecords.length > 0">
                                        <i class="fas fa-check"></i> <span>Autorizar Selección ({{
                                            selectedRecords.length
                                        }})</span>
                                    </button>
                                </div>
                                <button @click="goBack" class="btn btn-warning mb-0 ms-2">
                                    <i class="bi bi-chevron-left"></i> Volver
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <div v-if="!noRecords">
                                <div class="mb-2">
                                    Semana del <b>{{ formatShortDate(data.start_date) }}</b> al <b>{{
                                        formatShortDate(data.end_date)
                                    }}</b> de <b>{{ data.name }} </b><br>
                                </div>
                                <div class="mb-2 d-flex">
                                    <div>
                                        <b><span class="badge badge-warning">{{ notAuthWeekStats.total_hours.toFixed(1)
                                        }}
                                                hrs
                                                Totales</span></b>
                                    </div>
                                    <div>
                                        <b><span class="badge badge-success ms-1">{{
                                            notAuthWeekStats.regular_hours.toFixed(1) }} hrs
                                                Regulares</span></b>
                                    </div>
                                    <div>
                                        <b><span class="badge badge-danger ms-1">{{
                                            notAuthWeekStats.extra_hours.toFixed(1)
                                                }} hrs
                                                Extra</span></b>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <input type="checkbox" @change="toggleSelectAll"
                                                        :checked="isAllSelected"
                                                        class="form-check-input border border-secondary">
                                                </th>
                                                <th>Fecha</th>
                                                <th>Horas</th>
                                                <th>Tiempo</th>
                                                <th>Acciones</th>
                                                <th>Aut. PM?</th>
                                                <th>En Planta?</th>
                                                <th>Proyecto</th>
                                                <th>Actividad</th>
                                                <th>Notas</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(record, idx) in notAuthRecords" :key="idx">
                                                <td>
                                                    <input type="checkbox" :value="record.time_record_id"
                                                        v-model="selectedRecords"
                                                        class="form-check-input border border-secondary">
                                                </td>
                                                <td>{{ formatShortDate(formatToLocalYMD(record.date)) }}</td>
                                                <td><b>{{ record.total_hours }}</b></td>
                                                <td :class="record.is_extra_time ? 'bg-danger text-white' : ''">
                                                    {{ record.is_extra_time ? 'EXTRA' : 'REGULAR' }}</td>
                                                <td>
                                                    <div>
                                                        <button class="btn btn-success mb-0"
                                                            @click="authTimeRecord(record.time_record_id)">
                                                            <i class="fas fa-check"></i>
                                                        </button>
                                                        <button class="btn btn-warning mb-0 ms-2"
                                                            @click="editRecord(record.time_record_id)">
                                                            <i class="fas fa-pencil-alt icon-small"></i>
                                                        </button>
                                                        <button class="btn btn-danger mb-0 ms-2"
                                                            @click="deleteRecord(record.time_record_id)">
                                                            <i class="fas fa-trash icon-small"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td :class="record.auth_by_pm ? 'bg-success text-white' : ''">
                                                    {{ record.auth_by_pm ? 'SI' : 'NO' }}
                                                </td>
                                                <td :class="record.on_site ? 'bg-warning text-white' : ''">
                                                    {{ record.on_site ? 'SI' : 'NO' }}
                                                </td>
                                                <td>{{ record.client }} - {{ record.project }}</td>
                                                <td>{{ record.activity }}</td>
                                                <td>{{ record.notes }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="noRecords">
                                No hay registros pendientes por autorizar.
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="authRecords.length > 0" class="card mt-4">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección de Título -->
                            <div>
                                <h6 class="mb-2 ms-2">Registros Autorizados del Colaborador</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <div>
                                <div class="mb-2">
                                    Semana del <b>{{ formatShortDate(data.start_date) }}</b> al <b>{{
                                        formatShortDate(data.end_date)
                                    }}</b> de <b>{{ data.name }} </b><br>
                                </div>
                                <div class="mb-2 d-flex">
                                    <div>
                                        <b><span class="badge badge-warning">{{ authWeekStats.total_hours.toFixed(1)
                                        }}
                                                hrs
                                                Totales</span></b>
                                    </div>
                                    <div>
                                        <b><span class="badge badge-success ms-1">{{
                                            authWeekStats.regular_hours.toFixed(1) }} hrs
                                                Regulares</span></b>
                                    </div>
                                    <div>
                                        <b><span class="badge badge-danger ms-1">{{
                                            authWeekStats.extra_hours.toFixed(1)
                                                }} hrs
                                                Extra</span></b>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Horas</th>
                                                <th>Tiempo</th>
                                                <th>Aut. PM?</th>
                                                <th>Proyecto</th>
                                                <th>Actividad</th>
                                                <th>Notas</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(record, idx) in authRecords" :key="idx">
                                                <td>{{ formatShortDate(formatToLocalYMD(record.date)) }}</td>
                                                <td><b>{{ record.total_hours }}</b></td>
                                                <td :class="record.is_extra_time ? 'bg-danger text-white' : ''">
                                                    {{ record.is_extra_time ? 'EXTRA' : 'REGULAR' }}</td>
                                                <td>
                                                    <span>{{ record.auth_by_pm ? 'SI' : 'NO' }}</span>
                                                </td>
                                                <td>{{ record.client }} - {{ record.project }}</td>
                                                <td>{{ record.activity }}</td>
                                                <td>{{ record.notes }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData2" @close="closeModal">
    </Modal>
</template>
<script setup>
import { ref, onMounted, shallowRef, computed } from "vue"
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

// Related Modal
import Modal from "./components/Modal.vue";
import AuthEditTimeRecord from "./components/forms/AuthEditTimeRecord.vue";
import LoadingScreen from "./components/LoadingScreen.vue";

const isModalOpen = ref(false);
const selectedFormComponent = shallowRef(null);
const modalTitle = ref("");
const selectedData2 = ref(null)
const formComponents = { AuthEditTimeRecord: AuthEditTimeRecord }

const selectedRecords = ref([])

const isAllSelected = computed(() => {
    return notAuthRecords.value.length > 0 &&
        selectedRecords.value.length === notAuthRecords.value.length
})

// Función para seleccionar/deseleccionar todos
const toggleSelectAll = () => {
    if (isAllSelected.value) {
        selectedRecords.value = []
    } else {
        selectedRecords.value = notAuthRecords.value.map(record => record.time_record_id)
    }
}

const openModal = (data, formType) => {
    selectedData2.value = data || {}; // Si no se pasa nada, se inicializa como objeto vacío
    selectedFormComponent.value = formComponents[formType] || null;
    const titles = {
        AuthEditTimeRecord: 'Editar Registro de Tiempo',
    };
    modalTitle.value = titles[formType] || "Editar Información";
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};

const route = useRoute()
const router = useRouter()

const notAuthRecords = ref([])
const notAuthWeekStats = ref(null)
const authRecords = ref([])
const authWeekStats = ref(null)

const isLoaded = ref(false)
const noRecords = ref(false)
const data = ref({})

const formatShortDate = (dateYMD) => {
    const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
    const months = ['Enero', 'Feb', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Sept', 'Oct', 'Nov', 'Dic'];

    const [year, month, day] = dateYMD.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    const weekDay = days[date.getDay()];
    const day2 = date.getDate();
    const month2 = months[date.getMonth()];

    return `${weekDay} ${day2} ${month2}`;
}

const formatToLocalYMD = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';

    // Ajuste: sumar 1 día para evitar el desplazamiento UTC
    d.setDate(d.getDate() + 1);

    return d.toLocaleDateString('sv-SE'); // formato YYYY-MM-DD
};


const getNotAuthRecords = async () => {
    const body = {
        user_id: data.value.user_id,
        start_date: data.value.start_date,
        end_date: data.value.end_date
    };
    try {
        const response = await axios.post(`${API_BASE_URL}/week-not-auth-tr-by-user`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200 && response.data.success) {
            notAuthRecords.value = response.data.data;
            notAuthWeekStats.value = response.data.stats;
            if (notAuthRecords.value.length === 0) { noRecords.value = true }
        } else {
            console.error('Error al obtener los registros de tiempo');
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error);
    }
};

const getAuthRecords = async () => {

    const body = {
        user_id: data.value.user_id,
        start_date: data.value.start_date,
        end_date: data.value.end_date
    };
    try {
        const response = await axios.post(`${API_BASE_URL}/week-auth-tr-by-user`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200 && response.data.success) {
            authRecords.value = response.data.data;
            authWeekStats.value = response.data.stats
        } else {
            console.error('Error al obtener los registros de tiempo');
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error);
    }

}

const refreshData = async () => {
    await getNotAuthRecords()
    await getAuthRecords()
    isLoaded.value = true
}

const authorizeSelected = async () => {

    const body = { selected_records: selectedRecords.value }

    try {
        const response = await axios.post(`${API_BASE_URL}/auth-selected-records`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            alert('Registros del usuario Autorizados')
            selectedRecords.value = []
            await refreshData();
            return;
        } else {
            alert('Error al realizar la acción')
            return;
        }
    } catch (error) {
        alert('Error en la solicitud:', error);
        return;
    }
}

const authAll = async () => {
    const body = {
        user_id: data.value.user_id,
        start_date: data.value.start_date,
        end_date: data.value.end_date
    }
    if (!confirm('¿Estás seguro de autorizar la semana completa del colaborador? Esta acción NO puede deshacerse')) {
        return;
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/auth-week-by-user`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            alert('Registros del usuario Autorizados')
            await refreshData();
            return;
        } else {
            alert('Error al realizar la acción')
            return;
        }
    } catch (error) {
        alert('Error en la solicitud:', error);
        return;
    }

}

const authTimeRecord = async (id) => {

    if (!confirm('¿Seguro que deseas autorizar este registro del usuario?')) { return; }

    const body = { time_record_id: id }

    try {
        const response = await axios.post(`${API_BASE_URL}/auth-tr`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            alert('Registro Autorizado')
            await refreshData()
        } else {
            console.error('Error al obtener los registros de tiempo');
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error);
    }
}

const editRecord = async (id) => {
    const data = { time_record_id: id }
    openModal(data, 'AuthEditTimeRecord')
}

const deleteRecord = async (id) => {

    if (!confirm('¿Seguro que deseas eliminar este registro del usuario?')) { return }

    const body = { time_record_id: id }

    try {
        const response = await axios.post(`${API_BASE_URL}/remove-time-record`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            alert('Registro eliminado')
            await refreshData();
        } else {
            console.error('Error al obtener los registros de tiempo');
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error);
    }

}

const goBack = () => {
    router.back()
}

onMounted(async () => {
    // Obtener datos de los query params
    data.value = {
        user_id: route.query.user_id,
        start_date: route.query.start_date,
        end_date: route.query.end_date,
        name: route.query.name
    }

    // Validar que existan los datos necesarios
    if (!data.value.user_id) {
        router.push({ name: 'Home' })
    }
    await refreshData()
});

</script>
